import { Button } from "@/modules/shadcn/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/modules/shadcn/ui/dialog";
import { useTranslation } from "react-i18next";

interface DeleteLimitDialogProps {
  onCancel: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  title?: string;
  description?: string;
  confirmLabel?: string;
}

export const DeleteLimitDialog = ({
  onCancel,
  onConfirm,
  isLoading = false,
  title,
  description,
  confirmLabel,
}: DeleteLimitDialogProps) => {
  const { t } = useTranslation(["dashboard", "common"]);
  return (
    <Dialog open onOpenChange={(open) => !open && !isLoading && onCancel()}>
      <DialogContent showCloseButton={false}>
        <DialogHeader>
          <DialogTitle className="text-base font-bold">
            {title ?? t("deleteLimit.title")}
          </DialogTitle>
          <DialogDescription>
            {description ?? t("deleteLimit.description")}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" size="sm" onClick={onCancel} disabled={isLoading}>
            {t("common:actions.cancel")}
          </Button>
          <Button
            variant="destructive"
            size="sm"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading
              ? t("deleteLimit.deleting")
              : (confirmLabel ?? t("deleteLimit.confirm"))}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
